import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
  Box,
  Paper,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { useAPI } from '../../utils/api';

const useStyles = makeStyles({
  root: {
    '&:last-of-type td': {
      borderBottom: 'none',
    },
  },
});

const columns = [
  {
    id: 'orderStatus',
    label: '目前狀態',
  },
  {
    id: 'timeStamp',
    label: '紀錄時間',
  },
  {
    id: 'courier',
    label: '配送人員',
  },
  {
    id: 'courierPhone',
    label: '聯絡電話',
  },
  {
    id: 'remarks',
    label: '備註',
  },
];

const RecordStatusPage = () => {
  const classes = useStyles();
  const { orderID } = useParams();
  const api = useAPI();

  const [statusLogs, setStatusLogs] = useState([]);
  const [isUnmounted, setIsUnmounted] = useState(false);

  useEffect(() => {
    api
      .getOrderStatusLog({ id: orderID })
      .then((statusData) => {
        if (!isUnmounted) {
          const rows = [];
          statusData.map((item) => {
            rows.push(item);
          });

          setStatusLogs(rows);
        }
      })
      .catch(() => {});

    return () => {
      setIsUnmounted(true);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box
        sx={{
          padding: { xs: 1, sm: 2, md: 3, lg: 4 },
          maxWidth: '900px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <Paper
          elevation={4}
          sx={{
            width: '100%',
            paddingLeft: { xs: 2, sm: 3 },
            paddingRight: { xs: 2, sm: 3 },
            paddingTop: 4,
            paddingBottom: 2,
            marginBottom: 4,
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          <Box variant="body" marginRight={4} marginBottom={2}>
            <Typography variant="body2" mb={2}>
              您所輸入的訂單編號及查詢結果如下:
            </Typography>
            <Typography display="inline" variant="h5" fontWeight="bold">
              訂單編號：
            </Typography>
            <Typography display="inline" variant="h5">
              {orderID}
            </Typography>
          </Box>

          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {statusLogs && columns
                    ? columns.map((column, index) => (
                        <TableCell
                          key={`${column.id}-${index}`}
                          align={column.align || 'center'}
                          sx={{
                            minWidth: column.minWidth || 'none',
                            padding: 1,
                            maxWidth: '100%',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))
                    : undefined}
                </TableRow>
              </TableHead>

              <TableBody>
                {statusLogs
                  ? statusLogs.map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={`${index}`}
                          className={classes.root}
                        >
                          {statusLogs && columns
                            ? columns.map((column, index) => {
                                return (
                                  <TableCell
                                    key={`${column.id}-${index}`}
                                    align={column.align || 'center'}
                                    sx={{
                                      padding: 1,
                                      minHeight: '0',
                                      maxWidth: '100%',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {row[column.id]}
                                  </TableCell>
                                );
                              })
                            : undefined}
                        </TableRow>
                      );
                    })
                  : undefined}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </>
  );
};

export default RecordStatusPage;
